import * as React from 'react';
import { PropsWithChildren, useMemo } from 'react';
import { initialState, reducer } from 'state/reducers/auth';
import { AuthContext } from 'models/authContext';
import {
  changeAccessToken,
  clearAuthErrors,
  logIn,
  logOut,
  verifyAuthCode,
  getUser,
  setPassword,
  setIsAuthenticated,
} from 'requests/auth';
import {
  IAuthBodyRequest,
  IAuthResponse,
  ISetPasswordBodyRequest,
  IVerifyAuthCodeBodyRequest,
} from 'models/auth';

export const AuthProvider = ({ children }: PropsWithChildren<{}>) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [state, dispatch] = React.useReducer(reducer, initialState);

  const value = useMemo(
    () => ({
      ...state,
      logIn: (body: IAuthBodyRequest, successCallback?: (res: IAuthResponse) => void) =>
        logIn(dispatch, body, (res) => successCallback && successCallback(res)),
      logOut: (successCallback: () => void) => logOut(dispatch, () => successCallback()),
      changeAccessToken: (accessToken: any) => changeAccessToken(dispatch, accessToken),
      verifyAuthCode: (
        body: IVerifyAuthCodeBodyRequest,
        successCallback: (res: boolean) => void,
        failureCallback: (res: string) => void,
      ) =>
        verifyAuthCode(
          dispatch,
          body,
          (res) => successCallback(res),
          (res) => failureCallback(res),
        ),
      setPassword: (
        body: ISetPasswordBodyRequest,
        successCallback?: (res: IAuthResponse) => void,
      ) => setPassword(dispatch, body, (res) => successCallback && successCallback(res)),
      clearAuthErrors: () => clearAuthErrors(dispatch),
      getUser: () => getUser(dispatch),
      setIsAuthenticated: (isAuthenticated: boolean) =>
        setIsAuthenticated(dispatch, isAuthenticated),
    }),
    [state],
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
